<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <a v-go-back="'calls'">Teleatendimentos</a>
              <i class="right chevron icon divider"></i>
              <div class="active section">{{ sectionName }}</div>
            </Breadcrumb>
          </div>
          <div v-show="persisted" class="eight wide right aligned column">
            <div class="actions">
              <a
                class="section"
                :href="$router.resolve({ name: 'newCall' }).href"
              >
                <i class="plus icon"></i>Novo Teleatendimento
              </a>
              <a @click.prevent="openHistory">
                <i class="history icon"></i>Histórico
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <HistoryModal
        ref="history"
        resource="Teleatendimento"
        :item_id="form.id"
      />
      <UserSearchModal
        ref="doctor_search_modal"
        title="Selecione um médico"
        @selected="item => setDoctor(item)"
      />
      <UserSearchModal
        ref="patient_search_modal"
        title="Selecione um paciente"
        @selected="item => setPatient(item)"
      />
      <form
        :class="['ui small', { error: anyError }, 'form']"
        v-autocomplete-off
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div class="ui fields">
                <div
                  :class="[
                    'four wide required',
                    { error: errors.date },
                    'field'
                  ]"
                  :data-content="errorsTo('date')"
                >
                  <label for="contract-form-date">Data</label>
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="contract-form-date"
                    v-model="form.date"
                  />
                </div>
              </div>
              <div :class="[{ error: errors.doctor }, 'fields']">
                <div
                  :class="[
                    'four wide required',
                    { error: errors.doctor },
                    'field'
                  ]"
                  :data-content="errorsTo('doctor')"
                >
                  <label for="contract-form-doctor-id">Médico</label>
                  <div class="ui icon input">
                    <input
                      name="contract-form-doctor-id"
                      v-focus
                      type="text"
                      id="contract-form-doctor-id"
                      v-model="form.doctor_id"
                      @blur="setUserName($event.target.value, 'doctor_name')"
                    />
                    <i
                      class="circular search link icon"
                      @click.prevent="$refs.doctor_search_modal.open"
                    ></i>
                  </div>
                </div>
                <div class="twelve wide end field">
                  <input
                    disabled
                    type="text"
                    id="contract-form-doctor-name"
                    v-model="form.doctor_name"
                  />
                </div>
              </div>

              <div :class="[{ error: errors.patient }, 'fields']">
                <div
                  :class="[
                    'four wide required',
                    { error: errors.patient },
                    'field'
                  ]"
                  :data-content="errorsTo('patient')"
                >
                  <label for="contract-form-patient-id">Paciente</label>
                  <div class="ui icon input">
                    <input
                      name="contract-form-patient-id"
                      type="text"
                      id="contract-form-patient-id"
                      v-model="form.patient_id"
                      @blur="setUserName($event.target.value, 'patient_name')"
                    />
                    <i
                      class="circular search link icon"
                      @click.prevent="$refs.patient_search_modal.open"
                    ></i>
                  </div>
                </div>
                <div class="twelve wide end field">
                  <input
                    disabled
                    type="text"
                    id="contract-form-patient-name"
                    v-model="form.patient_name"
                  />
                </div>
              </div>

              <div class="twelve wide field">
                <label for="contract-form-doctor-url">Link Médico</label>
                <input
                  disabled
                  type="text"
                  id="contract-form-doctor-url"
                  v-model="form.doctor_url"
                />
              </div>

              <div class="twelve wide field">
                <label for="contract-form-patiend-url">Link Paciente</label>
                <input
                  disabled
                  type="text"
                  id="contract-form-patiend-url"
                  v-model="form.patient_url"
                />
              </div>
            </div>
          </div>
          <!-- row -->
          <div class="row">
            <div class="sixteen wide column">
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="save"
                  type="button"
                  name="save"
                  class="ui submit blue button"
                >
                  <i class="save icon"></i>Salvar
                </button>
                <a v-show="persisted" class="delete" @click.prevent="remove">
                  <i class="trash icon"></i>Remover Teleatendimento
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<style lang="css" scoped>
.warn {
  margin-right: 10px;
}
</style>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import UserSearchModal from '@/components/user_search_modal';
import PageLayout from '@/layouts/page_layout';
import HistoryModal from '@/components/history_modal';
const sleep = ms => new Promise(res => setTimeout(res, ms));

export default {
  name: 'ContractForm',
  components: {
    Breadcrumb,
    PageLayout,
    UserSearchModal,
    HistoryModal
  },

  filters: {
    shorCreditCard: function (value) {
      if (!value) return '';
      return `${value.substr(0, 4)}........${value.substr(12)}`;
    }
  },

  data() {
    return {
      loading: false,
      errors: {},
      plans: [],
      currentMemberIndex: null,
      newCreditCard: false,
      payment_methods: [],
      form: {
        date: this.$moment().format('DD/MM/YYYY'),
        id: null,
        doctor_id: null,
        patient_id: null,
        doctor_name: null,
        patient_name: null,
        doctor_url: null,
        patient_url: null
      }
    };
  },

  computed: {
    persisted() {
      return this.form.id != null;
    },

    sectionName() {
      return this.persisted
        ? `Editar Teleatendimento - ${this.form.id}`
        : 'Novo Teleatendimento';
    },

    anyError() {
      return !_.isEmpty(this.errors);
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      if (this.$route.params.id) {
        await this.fetch(this.$route.params.id);
      }
    },

    openHistory() {
      this.$refs.history.open();
    },

    setDoctor(item) {
      this.form.doctor_id = item.id;
      this.form.doctor_name = item.name;
    },

    setPatient(item) {
      this.form.patient_id = item.id;
      this.form.patient_name = item.name;
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    _setErrors(errors) {
      this.errors = _.clone(errors || {});
      setTimeout(() => {
        $('.error.field').popup();
      }, 100);
    },

    save() {
      this.loading = true;
      this._setErrors({});

      let data = _.clone(this.form);

      Api.calls
        .save(data)
        .then(async response => {
          this.$toast.show('Teleatendimento salvo com sucesso', 'success');
          this.form = this._parseCall(response.data.call_obj);
        })
        .catch(error => {
          if (error.response) {
            const errors = error.response.data.errors;
            const baseErrors = errors && errors.base;
            if (baseErrors && baseErrors.length) {
              this.$toast.show(baseErrors.join(', '), 'error');
            } else {
              this.$toast.show('Erro ao salvar teleatendimento', 'error');
            }
            this._setErrors(errors);
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },

    remove() {
      const removeIt = confirm('Remover Teleatendimento?');
      if (removeIt) {
        this.loading = true;
        Api.calls
          .destroy(this.form.id)
          .then(async () => {
            this.$toast.show('Teleatendimento removido com sucesso', 'success');
            this.$router.push({ name: 'calls' });
          })
          .catch(error => {
            if (error.response) {
              const errors = error.response.data.errors;
              const baseErrors = errors && errors.base;
              if (baseErrors && baseErrors.length) {
                this.$toast.show(baseErrors.join(', '), 'error');
              } else {
                this.$toast.show('Erro ao remover teleatendito', 'error');
              }
              this._setErrors(errors);
            } else {
              throw error;
            }
          })
          .finally(() => {
            this.$scrollTop();
            this.loading = false;
          });
      }
    },

    _parseCall(call) {
      call.date = call.date
        ? this.$moment(call.date, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : null;
      return call;
    },

    fetch(id) {
      this.loading = true;
      Api.calls
        .fetch(id)
        .then(async response => {
          this.form = this._parseCall(response.data.call_obj);
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show('Erro ao buscar teleatendimento', 'error');
            this.$router.push({ name: 'calls' });
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },

    async setUserName(id, field) {
      try {
        await sleep(10);
        if (_.isEmpty(this.form[field]) && !_.isEmpty(id)) {
          const response = await Api.users.fetch(id);
          const user = response.data.user;
          this.form[field] = user.name;
        }
      } catch (err) {
        if (err.response) {
          this.$toast.show('Erro ao buscar usuário', 'error');
        } else {
          throw err;
        }
      }
    }
  }
};
</script>
